module.exports = __webpack_public_path__ + "ProximaNova-70590d7a3979cb4d618e4d19e064d4df.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/ProximaNova.ttf
// module id = 166
// module chunks = 1